export default {
  label: 'Género',
  placeholder: 'Todos',
};
